import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
// import * as loader from '../Assets/Preloaders/238.gif'
import {removeQuote} from '../Actions/Quote_actions'

 import { connect } from 'react-redux';
// import DoneIcon from '@material-ui/icons/Done';

import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';


const FIGURE = styled.figure`
width: 100%;
display: flex;
place-content: center center;
padding: 0;
margin: 0;
position: relative;
`
const BANNER = styled.img`
border-radius: .5rem;
height: 50%;
width: inherit;
align-self: center;
margin: 0;
padding: 0;

`

const OVERLAY = styled.div`
border-radius: .5rem;
position: absolute;
background: black;
opacity: .8;
width: 100%;
height: 100%;
`

const ADVERT = styled(OVERLAY)`
background: transparent;
opacity: 1;
height: 100%;

& p {
    
    text-align: center;
    border: 2px solid white;
    width: 85%;
    font-weight: medium;
    margin: auto auto 0 auto;
    padding: 1rem;
    color: white;
    font-size: 1rem;
    line-height: 2rem;
    overflow: hidden;
    height: 45%;
    @media screen and (min-width: 48rem) {
        margin: 3rem auto 0 auto;
        height: 45%;
        font-size: normal;
        overflow: hidden;
         
    }

}

& ul {
     
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 3rem;
    line-height: 2rem;
}
& ul li {
         list-style-type: none;
         font-weight: bold;
}
`

const QUOTE = styled.section`
     margin: 2rem auto 1rem auto;
     padding-left: .5rem;
     padding-right: .5rem;
     width: 34rem;
     
`
const QuoteCard = ({planBg, qRedux = [], dispatch, whoRenders = '', byRender = '' }) => {
     
    const[count, setcount] = useState(1)

    const[timerID, setID] = useState(null)

    const[colors, ] = useState(['brown','black', 'darkslategrey','darkslategray', 'dimgray','dimgrey', 'saddlebrown','black',  'dimgrey','darkslategrey','darkslategray', 'black'])

useEffect(() => {
        var interval = setInterval(() => setcount(count + 1), 10 * 1000)

        setID(interval)

         return () => clearInterval(interval)
    },[count])

      
if(count === colors.length) {
    clearInterval(timerID)

} 

    if(qRedux.length > 0) {

        return ( 
            <>
            <section style={{display:'flex', justifyContent:'space-around', flexWrap:'wrap'}}>

            {qRedux.map(({quote, _id}, i) => <QUOTE 
            key={i}
            >
                <FIGURE>
                        <BANNER src={'https://www.hdwallpapersfreedownload.com/uploads/large/special-days/happy-world-water-day-pc-desktop-hd.jpg'} />

                        <OVERLAY style={ i % 2 !== 0 ? {background: colors[count - 2]} : {background:colors[count]}}></OVERLAY>

                        <ADVERT style={whoRenders==='pushCard' ? {boxShadow:'0 0 4px 0px black'} : {}}>
                        <span style={whoRenders==='pushCard' ?{display:'none'} : { color: 'silver', cursor:'pointer'}} onClick={() => dispatch(removeQuote(_id)) } > <CancelOutlinedIcon style={{marginLeft:'90%', marginTop:'1rem', color:'red', fontWeight:'bold'}} />
                        </span>

                        <p 
                        style={whoRenders==='pushCard' ? {margin:`${byRender==='desk' ? '10% auto auto auto' : '3% auto auto auto'} `, height: 'auto', fontSize:'normal', overFlow:'hidden', padding: '.1rem'} : {}}>{quote.substring(0, 120) + '...'}</p>
                            
                        </ADVERT>
                </FIGURE>
            </QUOTE> 
            )}
            </section>
            
           
    
            </>
         );
    }
     else return <>  
     {/* <img  */}
    {/* // src={loader} 
    // alt='preloader' 
    // style={{marginTop:'20vh', display:'block', marginLeft:'180%'}} /> 
    // <small style={{display:'block', marginLeft:'18%'}} >No quote yet, waiting...</small>  */}
     </>
}

 
 
export default connect()(QuoteCard);